import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppointmentReason } from '@libs/store';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-reason-selector-modal-footer',
  imports: [CommonModule, SvgIconComponent, TranslateModule],
  templateUrl: './reason-selector-modal-footer.component.html',
  styleUrl: './reason-selector-modal-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReasonSelectorModalFooterComponent {
  public readonly items = signal<AppointmentReason[]>([]);

  @Input() public set selectedReasons(value: AppointmentReason[]) {
    this.items.set(value);
  }

  @Output() public readonly itemDeselected = new EventEmitter<AppointmentReason>();

  public deselectItem(item: AppointmentReason): void {
    this.itemDeselected.emit(item);
  }
}
